
import React, { useEffect, useState, forwardRef, useRef } from "react";
import ReactToPrint, { PrintContextConsumer, useReactToPrint } from "react-to-print";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { Link, useNavigate } from "react-router-dom";
import {
    Box, Button, Grid, Dialog, DialogTitle, TextField, DialogActions,
    TablePagination, Typography, InputAdornment, DialogContent, IconButton, Tooltip, Card, CardContent, Container, Popover, Divider, Hidden
} from '@mui/material';
import { Icon } from '@iconify/react';
import EditIcon from '@mui/icons-material/Edit';
import { SearchOutlined } from '@mui/icons-material';

import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import AddBoxIcon from '@mui/icons-material/AddBox';
// import PurchaseEntryPrint from "./PurchaseEntryPrint";
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
// import PurchaseEntryDetails from "./PurchaseEntryDetails";
import Breadcrumb from "../../reusableComponent/Breadcrumb";
import { StyledTableRow, StyledTableCell } from '../../reusableComponent/StyledTable'
import BackBtn from "../../reusableComponent/BackBtn";
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useDispatch, useSelector } from "react-redux";
import { editDeletePurchaseInvoice, getPurchaseInvoiceList } from "../../../actions/actions";
import DeleteSnackbar from "../../reusableComponent/DeleteSnackbar";
import { BootstrapDialog, BootstrapDialogTitle } from "../../reusableComponent/BootstrapDialog";
import AddIcon from '@mui/icons-material/Add';
import { dateConversion, dateConversionOnEntryPage } from "../../reusableComponent/dateConversionOnEntryPage";
import styles from '.././../../styles.module.css';
import ExcelDownload from "../../reusableComponent/ExcelDownload";
import upload_excel from '../../../images/upload_excel.png'
import PurchaseReturnDetails from "./PurchaseReturnDetails";
import PurchaseReturnAdd from "./PurchaseReturnAdd";

const ComponentToPrintRow = ({ value }) => {
    const { pEntryPrint } = value;
  
    return (
      <div className="print-source">
        {/* <PurchaseInvoicePrint value={pEntryPrint} /> */}
      </div>
    );
  };

  const ComponentToPrintPEntryWrapper = ({ pEntryPrint }) => {
    const ref = useRef();
  
    return (
      <div style={{ display: "flex" }}>
        <ReactToPrint
          trigger={() => <Icon icon="flat-color-icons:print" width="20" height="20" />}
          content={() => ref.current}
        />
        <div style={{ display: 'none' }}>
          <ComponentToPrintRow ref={ref} value={pEntryPrint} />
        </div>
      </div>
    );
  };

function PurchaseReturnList(props) {
    const dispatch = useDispatch();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;
    let ref = useRef();
    const tableRef = useRef(null);
    const [open, setOpen] = React.useState(false);
    const [openPopup, setOpenPopup] = React.useState(false);
    const [info, setInfo] = useState({});
    const [successMessage, setSuccessMessage] = useState(null);
    const [openOption, setOpenOption] = useState('');

    const handleClickOpenPopup = (info) => {
        setInfo(info);
        setOpenPopup(true);
        setOpenOption('PurchaseUpdate')
    };
    const [rowsPerPage, setRowsPerPage] = React.useState(10)
    const [page, setPage] = React.useState(0)

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value)
        setPage(0)
    }

    const [isLoaded, setIsLoaded] = useState(false);

    const [q, setQ] = useState("");
    const [searchParam] = useState(["inwardNo", "inwardDate", "orderDate", "invoiceNo", "vehicleNo", "transporter", "CNS_Name"]);

    const [isDelete, setIsDelete] = useState(false);
    const [deleteInfo, setDeleteInfo] = useState();

    const header = ["Inward No", "Inward Date", "Invoice No", "Invoice Date", "Order No", "Supplier Name"];
    const body = [];

    const rows = useSelector(state => state.purchaseInvoice.purchaseInvoice)
    const fetchData = () => {
        dispatch(getPurchaseInvoiceList({ companyId: userInfo.companyId }))
    };
    useEffect(() => {
        fetchData()
    }, []);
    const [deleteMessage, setDeleteMessage] = useState(null);
    const [shouldShowMsg, setShouldShowMsg] = useState(false);
    const responseMessage = useSelector(state => state.purchaseInvoice.message);

    useEffect(() => {
        if (responseMessage) {
            setShouldShowMsg(true);
            setDeleteMessage(responseMessage);
        }
    }, [responseMessage, dispatch]);

    useEffect(() => {
        if (shouldShowMsg) {
            if (responseMessage !== null) {
                setSuccessMessage(responseMessage);
                setShouldShowMsg(false);
                setDeleteMessage(responseMessage);
                dispatch({ type: 'RESET_MESSAGE' }); // Dispatch an action to reset the message
                fetchData();
                setOpenPopup(false);
            }
        }
    }, [shouldShowMsg, responseMessage, fetchData]);


    const deleteRecord = (id) => {
        dispatch(editDeletePurchaseInvoice({ id: id, modifiedBy:  userInfo.userId, modifiedAt: dateConversionOnEntryPage(new Date()), changedUpdatedValue: 'delete' }))
        setIsDelete(false);
        fetchData()
    }

    const handleDelete = (functions) => {
        setIsDelete(true);
        setDeleteInfo(functions);
        setOpen(false);
    }

    const handleClose = (event, reason) => {
        setIsDelete(false)
        setDeleteInfo(null);
        setOpen(false);
        setOpenPopup(false);
    };
    const handleDetails = (info) => {
        setInfo(info);
        setOpenPopup(true);
        setOpenOption('PurchaseDetails')
    }
    function search(rows) {
        return rows && rows.filter((item) => {
            return searchParam.some((newItem) => {
                return (
                    item[newItem] && item[newItem]
                        .toString()
                        .toLowerCase()
                        .indexOf(q.toLowerCase()) > -1
                );
            });
        });
    }
    const [sortBy, setSortBy] = useState(null);
    const handleSort = (property) => {
        const isAsc = sortBy === property && sortBy !== null;
        setSortBy(isAsc ? property + '_desc' : property);
        rows.sort((a, b) => {
            if (typeof a[property] === 'number' && typeof b[property] === 'number') {
                return isAsc ? a[property] - b[property] : b[property] - a[property];
            } else {
                return isAsc ? a[property].localeCompare(b[property]) : b[property].localeCompare(a[property]);
            }
        });
    };

//     const handleSort = (property) => {
//   const isAsc = sortBy === property && sortBy !== null;
//   setSortBy(isAsc ? property + '_desc' : property);
//   rows && rows.sort((a, b) => {
//     if (typeof a[property] === 'number' && typeof b[property] === 'number') {
//       return isAsc ? a[property] - b[property] : b[property] - a[property];
//     } else if (typeof a[property] === 'string' && typeof b[property] === 'string') {
//       return isAsc ? a[property].localeCompare(b[property]) : b[property].localeCompare(a[property]);
//     } else {
//       // Handle other data types here, or you can set a default value if needed
//       // For example, you can return 0 to indicate no sorting needed for other data types.
//       return 0;
//     }
//   });
// };

    const fields = ['id', 'unitName',];
    const labels = ['Id', 'Unit',];
    const handleUpload = () => {
        // fileInputRef.current.click();
    };

    // const handleFileChange = (event) => {
    //     const selectedFile = event.target.files[0];
    //     const formData = new FormData();
    //     formData.append('file', selectedFile);

    //     selectedFile !== '' &&
    //         dispatch(uploadUnitData(formData));
    // };
    return (
        <>
            <Paper className={`${styles.list_container}`}>
                <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Breadcrumb
                        routeSegments={[
                            { name: 'Purchase', path: '/purchase' },
                            { name: 'Purchase Invoice' },
                        ]}
                    />
                    <Button onClick={props.handlePreviousBtn} disabled={props.previousBtn.length === 0}
                        className={`${styles.back_btn}`}>
                        <Icon icon="icon-park-twotone:back" className={`${styles.back_icon}`} /> Go Back</Button>
                </Box>
                <Box sx={{ display: 'flex' }}>
                    <Grid container spacing={0.2} sx={{ pt: 0.5, pb: 0.5 }}>
                        <Grid item md={7} xs={4}>
                            <Typography className={`${styles.page_title}`}> Purchase Return List</Typography>
                        </Grid>
                        <Grid item md={5} xs={8} style={{ display: 'flex', }}>
                            <Box className={`${styles.excel_box}`}>
                                <ExcelDownload
                                    data={rows}
                                    fields={fields}
                                    labels={labels}
                                    filename="Event List"
                                />
                            </Box>
                            <Box className={`${styles.excel_box}`}>
                                {/* <input
                                    ref={fileInputRef}
                                    type="file"
                                    name="file"
                                    style={{ display: 'none' }}
                                    onChange={handleFileChange}
                                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                /> */}
                                <Tooltip title="Upload Excel File">
                                    {/* <Button variant="outlined" className="btn-outline" style={{ marginRight: '8px' }}>
                                        <Icon icon="mdi-light:upload" color="black" width="20" height="20" onClick={handleUpload} htmlFor="file-upload" />
                                    </Button> */}
                                    <span onClick={handleUpload} htmlFor="file-upload"> <img src={upload_excel} style={{ height: "20px", width: "20" }} /> </span>
                                </Tooltip>
                            </Box>
                            <TextField
                                fullWidth
                                sx={{
                                    "& .MuiInputBase-root": {
                                        height: 25,
                                        fontSize: '11px',
                                        paddingLeft: '1px',
                                    }
                                }}
                                type="search"
                                name="search"
                                placeholder="Search"
                                value={q}
                                size="small"
                                onChange={(e) => setQ(e.target.value)}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start" >
                                            <IconButton sx={{ padding: '4px' }}>
                                                <SearchOutlined className={`${styles.search_icon}`} />
                                                <Divider orientation="vertical" flexItem />
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}
                            />
                            <Button variant="contained" onClick={handleClickOpenPopup} className={`${styles.add_btn}`}>
                                <AddIcon viewBox="3 3 18 18" className={`${styles.add_icon}`} /> Create New
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
                <TableContainer component={Paper} style={{ overflowY: 'auto', maxHeight: 350 }}>
                    <Table sx={{ minWidth: 650 }} size="small" stickyHeader ref={tableRef}>
                        <TableHead>
                            <StyledTableRow>
                                <StyledTableCell align="center" className={`${styles.table_head}`} style={{ width: '150px' }}>Action</StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('debitNoteNo')}>Debit Note No <span className={`${styles.sort_icon}`}> {sortBy === 'debitNoteNo' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('debitNoteDate')}>Date <span className={`${styles.sort_icon}`}> {sortBy === 'debitNoteDate' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('supplierName')}>Supplier Name <span className={`${styles.sort_icon}`}> {sortBy === 'supplierName' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('againstInvoiceDate')}>Against Invoice Date <span className={`${styles.sort_icon}`}> {sortBy === 'againstInvoiceDate' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('InwardNo')}>Against Invoice No <span className={`${styles.sort_icon}`}> {sortBy === 'InwardNo' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('otherReference')}>Other Reference <span className={`${styles.sort_icon}`}> {sortBy === 'otherReference' ? '▲' : '▼'} </span></StyledTableCell>
                            </StyledTableRow>
                        </TableHead>
                        <TableBody>
                            {rows && search(rows)
                                .slice(
                                    page * rowsPerPage,
                                    page * rowsPerPage + rowsPerPage
                                )
                                .map((row, index) => (
                                    <StyledTableRow
                                        key={row.id}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                        <StyledTableCell align="center" className='listTableBody'>
                                            <PopupState variant="popover" popupId="demo-popup-popover">
                                                {(popupState) => (
                                                    <div>
                                                        <MoreHorizIcon
                                                            id={styles.actionBtn}
                                                            alt="translator"
                                                            variant="contained"
                                                            {...bindTrigger(popupState)}
                                                        />
                                                        <Popover
                                                            {...bindPopover(popupState)}
                                                            anchorOrigin={{
                                                                vertical: "right",
                                                                horizontal: "center"
                                                            }}
                                                            transformOrigin={{
                                                                vertical: "right",
                                                                horizontal: "center"
                                                            }}
                                                        >
                                                            <Container className={`${styles.tbl_action}`}>
                                                                <>
                                                                    <Button className={`${styles.list_tbl_action_btn}`} onClick={() => handleClickOpenPopup(row)}>
                                                                        <EditIcon style={{ float: 'left', fontSize: '20px', cursor: 'pointer' }} />
                                                                        <span style={{ marginRight: '13px' }}> Edit Record</span> </Button>
                                                                    <Button className={`${styles.list_tbl_action_btn}`}>
                                                                    <ComponentToPrintPEntryWrapper key={index} pEntryPrint={row} />
                                                                    </Button>
                                                                    <Button className={`${styles.list_tbl_action_btn}`} onClick={(e) => handleDelete(row)}>
                                                                        <Icon icon="ic:baseline-delete-forever" color="#c70000" width="20" height="20" /> Delete Record
                                                                    </Button>
                                                                </>
                                                            </Container>
                                                        </Popover>
                                                    </div>
                                                )}
                                            </PopupState>
                                        </StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`} sx={{ color: 'blue' }} onClick={() => handleDetails(row)}>
                                            <span style={{ cursor: 'pointer', color: 'blue' }} > {row.inwardNo}</span>
                                        </StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{dateConversion(row.debitNoteDate)}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.supplierName.supplierName}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{dateConversion(row.againstInvoiceDate)}</StyledTableCell>
                                        {/* <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.againstInvoiceNo.InwardNo}</StyledTableCell> */}
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.otherReference}</StyledTableCell>
                                    </StyledTableRow>
                                ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    sx={{ px: 2 }}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    backIconButtonProps={{
                        'aria-label': 'Previous Page',
                    }}
                    nextIconButtonProps={{
                        'aria-label': 'Next Page',
                    }}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
            <Dialog open={isDelete}
                PaperProps={{
                    sx: {
                        minWidth: "35%",
                        minHeight: "22%",
                        borderRadius: '8px'
                    }
                }}>
                <DialogTitle className={`${styles.dilog_delete_title}`}>
                    Confirm Delete The Record?
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            right: 0,
                            top: 0,
                            float: 'right'
                        }} >
                        <CloseIcon style={{ height: '18px', color: '#000000' }} />
                    </IconButton>
                </DialogTitle>
                <DialogContent className={`${styles.dilog_delete_content}`}>
                    The BillCube will remove this record # {deleteInfo && deleteInfo.inwardNo}
                </DialogContent>
                <DialogActions sx={{ padding: '10px', }}>
                    <Button onClick={handleClose} className={`${styles.dilog_delete_no_btn}`} variant='outlined'>
                        No
                    </Button>
                    <Button onClick={() => deleteRecord(deleteInfo._id)} className={`${styles.dilog_delete_yes_btn}`} variant='outlined'>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>

            <BootstrapDialog
                PaperProps={{
                    sx: {
                        maxWidth: "85%",
                        height: "95%"
                    }
                }}
                onClose={handleClose}
                open={openPopup}
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose} >
                    {openOption === 'PurchaseUpdate' && 'Update Purchase Return'}
                    {openOption === 'PurchaseDetails' && 'Purchase Return Details'}
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    {openOption === 'PurchaseUpdate' &&
                        <PurchaseReturnAdd handleCloseDialog={handleClose} details={info} onAPISubmt={fetchData} />
                    }
                    {openOption === 'PurchaseDetails' &&
                        <PurchaseReturnDetails details={info} />
                    }
                </DialogContent>
            </BootstrapDialog>

            {deleteMessage &&
                <DeleteSnackbar
                    open={deleteMessage ? true : false}
                    message={deleteMessage}
                />
            }
        </>
    )
}



export default PurchaseReturnList